// @ts-nocheck
import * as React from "react"

export const Loader = (WrapperComponent: any) => (props: any) => {
    const [isLoading, setIsLoading] = React.useState<boolean>(true)
    const bodyElm = document.body

    const setLoadingState = (isComponentLoading: boolean) => {
        setIsLoading(isComponentLoading)
        fixedMenu(isComponentLoading)
    }

    const fixedMenu = (showedMenu: boolean): void => {
        if (showedMenu) bodyElm.style.overflow = 'hidden'
        if (!showedMenu) bodyElm.style.overflow = 'initial'
    }

    React.useEffect(() => {
        fixedMenu(true)
    }, [])

    return (
        <React.Fragment>
            <FSLoader loading={isLoading} />
            <WrapperComponent {...props} setLoading={setLoadingState} loading={isLoading} />
        </React.Fragment>
    )
}

const FSLoader = ({ loading }: any) => {
    return (
        <div className='af-fullscreen-loader' className={`af-fullscreen-loader${!loading ? ' hide' : ''}`}>
            <div className='es-loader'>
                <div className="es-loader__drops">
                    <div className="es-loader__drop1"></div>
                    <div className="es-loader__drop2"></div>
                </div>
                <div className='es-loader__fill'>
                    <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 24 150 28" preserveAspectRatio="none">
                        <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                        </defs>
                        <defs>
                            <filter id="liquid">
                                <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
                                <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="liquid" />
                            </filter>
                        </defs>
                        <g className="parallax">
                            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(57, 189, 229,0.7" />
                            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(57, 189, 229,0.5)" />
                            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(57, 189, 229,0.3)" />
                            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#39BDE5" />
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    )
}

export default Loader;